import VueScrollTo from "vue-scrollto";

export default {
  bind: (element: HTMLElement, binding) => {
    let scrollable = true;
    if (typeof binding.value !== "undefined") {
      scrollable = binding.value;
    }
    element.addEventListener("click", () => {
      scrollable && scroll();
    });
  },
};

const scroll = () => {
  VueScrollTo.scrollTo({ force: true });
};
